
/////////////////LOCAL////////////////////////////////////////////////
// export const BaseUrl ="http://localhost:2061/api"
// export const UrlPagos ="http://localhost:5173"
// export const UrlMulticotizador ="https://multicotizador.mercibroker.com.ar"
/////////////////////TEST/////////////////////////////////////////////
export const BaseUrl ="https://test.crm-old.mercibroker.com.ar/api"
export const UrlPagos ="https://test.pagos.mercibroker.com.ar"
export const UrlMulticotizador ="https://multicotizador.mercibroker.com.ar"